<template>
  <div v-if="value!==undefined">
    <div class="flex-end" style="margin-bottom:12px" v-if="isInternalPlugin('order_detail_print')">
      <button class="button is-primary" @click="printOrder($refs.orderDetail)">인쇄하기</button>
    </div>

    <div ref="orderDetail">
      <div class="columns is-multiline">
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="주문 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="주문 번호">{{ value.order_num }}</admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="주문 일자">{{ value.created_time }}</admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="주문자">{{ value.name }}</admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="주문자 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="주문자명(ID)">{{ value.name }}({{ value.email }})</admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="이메일">{{ value.email }}</admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="휴대전화">{{ value.phone }}</admin-form-item>
              </div>
              <!--<div class="column is-full">
                <admin-form-item :isFlex="true" label="일반전화">
                  {{ value.tphone }}
                </admin-form-item>
              </div>-->
            </div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-full">
        <div class="box">
          <admin-box-item title="주문 상품 정보">
            <admin-form-item label="주문 상품" style="margin-top:12px">
              <table class="delivery-orderproduct-table">
                <thead>
                <tr>
                  <th style="width:20%">상품 주문 번호</th>
                  <th style="width:25%">주문 상품</th>
                  <th style="width:10%">옵션 단가</th>
                  <th style="width:10%">할인 금액</th>
                  <th style="width:15%">주문 상태</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(op,idx) in order_product" :key="'op-'+idx">
                  <td style="width:20%">{{ op.id }}</td>
                  <td style="width:25%">
                    <div style="text-align: left">
                      <div>{{ op.product.name }}</div>
                      <div v-for="(item, idx) in op.option"
                           :key="`option-${idx}`">
                        <div>옵션: {{ item.name }} / {{ item.price | currency }}</div>
                      </div>
                    </div>
                  </td>
                  <td style="width:10%">{{ op.product_price | currency }}</td>
                  <td style="width:10%">{{ op.discount_price | currency }}</td>
                  <td style="width:15%">{{ op.status_kor }}</td>
                </tr>
                </tbody>
              </table>
            </admin-form-item>

          </admin-box-item>
        </div>
      </div>


      <div class="column is-full">
        <div class="box">
          <admin-box-item title="결제 정보">
            <div class="columns is-multiline">
              <div class="column is-4">
                <table class="delivery-order-info">
                  <tbody>
                  <tr>
                    <td class="order-info-title">총 주문 금액</td>
                    <td>{{ value.product_price | currency }}</td>
                  </tr>
                  <tr>
                    <td class="order-info-title">배송비</td>
                    <td>{{ value.delivery_cost | currency }}</td>
                  </tr>
                  <tr>
                    <td class="order-info-title">할인 금액</td>
                    <td>{{ value.discount_price | currency }}</td>
                  </tr>
                  <tr>
                    <td class="order-info-title">실 결제 금액</td>
                    <td>{{ value.total_price | currency }}</td>
                  </tr>
                  <tr v-if="isCard">
                    <td class="order-info-title">부분 취소 금액</td>
                    <td>{{ value.cancel_price | currency }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="column is-8">
                <table class="delivery-order-info">
                  <tbody>
                  <tr>
                    <td class="order-info-title">결제 수단</td>
                    <td>{{ value.pay_type_kor }}</td>
                  </tr>
                  <!-- 카드 결제 -->
                  <tr v-if="value.pay_type===0">
                    <td class="order-info-title">결제 카드 정보</td>
                    <td>
                      카드사:
                      <span v-if="value.pg_result.CARD_PurchaseName">{{ value.pg_result.CARD_PurchaseName }}</span>
                      <span v-else-if="value.pg_result.P_TID">{{ value.pg_result.P_CARD_PURCHASE_NAME }}</span>
                      <br>
                      TID:
                      <span v-if="value.pg_result.tid">{{ value.pg_result.tid }}</span>
                      <span v-else-if="value.pg_result.P_TID">{{ value.pg_result.P_TID }}</span>
                    </td>
                  </tr>
                  <tr v-if="value.pay_type===0">
                    <td class="order-info-title">카드 결제 상세 내역</td>
                    <td>카드결제: {{ payDate }} /
                      <span v-if="value.pg_result.TotPrice">{{ value.pg_result.TotPrice | currency }}</span>
                      <span v-else-if="value.pg_result.P_TID">{{ value.pg_result.P_AMT | currency }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="order-info-title">결제(입금자)</td>
                    <td>{{ value.name }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- 취소 상태 변경 -->
            <div v-if="showPayStatusChangeDiv">
              <div class="flex align-center" style="background-color: #eee; padding: 8px">
                <span></span>
                <span class="select" style="margin-left: 8px">
                  <select v-model="cancelStatus" @change="e => cancelStatus=parseInt(e.target.value)">
                    <option value="" disabled selected>취소 상태 변경</option>
                    <option :value="item.value" v-for="(item, idx) in cancel_status_arr" :key="'status-'+idx">{{ item.label }}</option>
                  </select>
                </span>
                <input class="input full has-text-right"
                       style="margin-left: 8px; width:250px"
                       v-model="cancelPrice"
                       @input="setCancelPrice"
                       v-if="cancelStatus===506"
                       type="number">
                <button class="button" style="margin-left:8px"
                        @click="openCancelModal">취소하기</button>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

    </div>
    </div>

    <!-- 전체 취소 모달 -->
    <modal name="allCancelModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        전체 취소 하시겠습니까?
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="confirmCancel">확인</button>
        </div>
      </div>
    </modal>

    <!-- 부분 취소 모달 -->
    <modal name="partCancelModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        부분 취소 하시겠습니까?
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="confirmCancel">확인</button>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import moment from 'moment';
  import DeliveryMixin from "@/mixins/DeliveryMixin"
  import Tab from "../../../module/common/Tab";


  export default {
    components: {
      Tab,
      LpCheckBool},
    name: "order-detail",
    mixins: [
      DeliveryMixin
    ],
    data() {
      return {
        value: undefined,
        // tableItems: 원본, order_product: 원본에서 필터링 된 것
        order_product: [],
        calcTotalPrice: 0,
        calcDiscountPrice: 0,
        calcQuantity: 0,
        check: false,
        // 일괄로 변경할 상태
        status: 0,
        status_arr: [],
        // 취소할 상태
        cancelStatus:0,
        cancel_status_arr: [
          {label:'전체취소',value:500},
          {label:'부분취소',value:506},
        ],
        // 부분 취소할 금액
        cancelPrice: 0,
        optionArr: [],
        start_status: 0,
        end_status: 0,
        selectedRefundId: 0,
        // 선택된 주문 상품
        selectedOrderProduct: [],
      }
    },
    created() {
      this.getDetail();
      this.getStatusList();
    },
    computed: {
      showPayStatusChangeDiv () {
        if(this.isCard) {
          // 전체 취소 또는 환불 없음 상태 노출 안함
          return !(this.value.is_cancel_all || this.value.no_refund);
        }
        else {
          return false;
        }
      },
      // 카드 결제 유무
      isCard() {
        return this.value.pay_type !== 2;
      },
      payDate() {
        let date = '';
        if(this.value.pg_result.applDate) {
          date = `${this.value.pg_result.applDate} ${this.value.pg_result.applTime}`;
          return moment(date).format('YYYY-MM-DD HH:mm:ss');
        }
        else {
          date = this.value.pg_result.P_AUTH_DT
          return date
        }
      },

    },
    methods: {
      // 주문 상품 선택
      selectOrderProduct () {
        let id_list = this.getCheckedArr();
        let selected = [];
        for(let i=0; i<id_list.length; i++) {
          let op = find(this.order_product, 'id', id_list[i]);
          // console.log(op)
          if(op) selected.push(op);
        }
        this.selectedOrderProduct = selected;
      },
      // 반품 접수
      requestRefund() {
        this.status = 700;
        this.clickChange();
      },
      // 교환 접수
      requestExchange () {
        this.status = 600;
        this.clickChange();
      },
      selectTab (value) {
        this.tab = value;
        let tableItems = [];
        // 교환 예외처리
        if(this.tab!==2) {
          this.selectedOrderProduct = [];
          this.exchange_order_product = [];
        }
        // 전체
        if(this.tab===0) {
          this.start_status = 0;
          this.end_status = 100000;
        }
        // 반품
        else if(this.tab===1) {
          this.start_status = 700;
          this.end_status = 706;
        }
        // 교환
        else if(this.tab===2) {
          this.start_status = 600;
          this.end_status = 609;
        }
        tableItems = this.tableItems.filter(item => {
          return item.status>=this.start_status &&item.status<=this.end_status
        })
        this.order_product = tableItems;
        let checkArr = [];
        for (let i = 0; i < this.order_product.length; i++) {
          checkArr.push({id: this.order_product[i].id, value: false})
        }
        this.checkArr = checkArr;
      },
      confirm (modal_name) {
        this.getDetail();
        this.$modal.hide(modal_name);
        if(modal_name==='exchangeModal') {
          this.selectedOrderProduct = [];
          this.exchange_order_product = [];
        }
      },
      // 상태값 목록
      getStatusList(){
        let page = this.$route.query.page;
        if(!page) return;
        this.$axios.get(this.getUrl(`commerce/order/status?page=${page}`)).then(res=>{
          if(res.status === 200){
            this.status_arr = res.data;
          }
        })
      },
      // 체크박스 일괄 선택
      clickCheckBoxAll(value) {
        this.checkArr.forEach(item => {
          item.value = value;
        })

        this.selectOrderProduct();

      },
      getDetail() {
        this.$axios.get(this.getUrl(`commerce/order/${this.$route.query.id}`)).then(res=> {
          this.value = res.data;
          let tableItems = res.data.order_product;
          let tableList = [];
          for(let i = 0; i < tableItems.length; i++) {
            tableList.push({id: tableItems[i].id, value: false});
          }
          this.checkArr = tableList;
          this.order_product = tableItems;
          // tableItems: 원본 데이터
          // order_product: tableItems를 필터링한 데이터
          this.tableItems = tableItems;


          this.calcTotal();

        })
      },
      calcTotal() {
        let total_price = 0;
        let discount_price = 0;
        let quantity = 0;
        this.order_product.forEach(op=> {
          discount_price += op.discount_price;
          total_price += op.total_price;
        })
        this.calcTotalPrice = total_price;
        this.calcDiscountPrice = discount_price;
      },
      // 취소, 부분취소
      openCancelModal() {
        if(this.cancelStatus===500) {
          if(this.value.cancel_price>0) {
            this.toast('부분취소를 하여 전체취소가 불가능합니다.');
            this.$modal.hide('allCancelModal');
          }
          else this.$modal.show('allCancelModal');
        }
        else if(this.cancelStatus===506) {
          this.$modal.show('partCancelModal');
        }
      },
      // 부분 취소 금액 입력
      setCancelPrice(e) {
        let price = parseInt(e.target.value);
        this.cancelPrice = price;
      },
      confirmCancel() {
        // 전체 취소
        if(this.cancelStatus===500) {
          let url = `commerce/order/${this.$route.query.id}/status/change`;
          this.$axios.post(this.getUrl(url), {
            status: 500
          }).then(res=> {
            if(res.status===200) {
              this.toast('전체 취소가 완료되었습니다.');
              this.$modal.hide('allCancelModal');
              this.getDetail();
            }
          }).catch(error => {
            this.toast(error.response.data.message);
            this.$modal.hide('allCancelModal');
          });
        }
        // 부분 취소
        else if(this.cancelStatus===506) {
          let url = `commerce/order/${this.$route.query.id}/cancelprice`;
          // let url = `http://localhost:8000/admin/delivery/order/${this.$route.query.id}/cancelprice`;
          this.$axios.post(this.getUrl(url), {
            cancel_price: this.cancelPrice
          }).then(res=> {
            if(res.status===200) {
              this.toast('부분 취소가 완료되었습니다.');
              this.$modal.hide('partCancelModal');
              this.getDetail();
            }
          }).catch(error=> {
            this.toast(error.response.data.message);
            this.$modal.hide('partCancelModal');
            this.getDetail();
          })
        }
      },
      printOrder(elementRef) {
        let app = document.getElementById('app')
        const printContents = elementRef.innerHTML
        let printDiv = document.createElement('DIV')
        document.body.appendChild(printDiv)
        printDiv.innerHTML = printContents
        app.style.display = 'none'
        setTimeout(() => {
          window.print()
          app.style.display = 'block'
          printDiv.style.display = 'none'
          printDiv.innerHTML = ''
        }, 500)
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .delivery-orderproduct-table
  .delivery-order-info
    width 100%

  .delivery-orderproduct-table th
    background-color #eee

  .delivery-orderproduct-table th
  .delivery-orderproduct-table td
  .delivery-order-info td
    text-align center !important
    border 1px solid #e0d9d9
    padding 6px
    vertical-align middle !important

  .delivery-orderproduct-table .table-result
    background-color #EBEAE4

  .delivery-order-info .order-info-title
  .order-info-title
    background-color #eee
</style>
